import { AABBModel } from './AABBModel';

export enum MiniGameTypeEnum {
    none = '100',
    stand_flyers = 'stand_flyers',
    currency_exchange = 'currency_exchange',
    dinner = 'dinner',
    electricity = 'electricity',
    approve_the_loan = 'approve_the_loan',
    lock_cell = 'lock_cell',
    block_cards = 'block_cards',
    send_a_letter = 'send_a_letter',
    bussines_trip = 'bussines_trip',
    print_card = 'print_card',
}

export class MiniGameModel extends AABBModel {
    public visible: boolean = false;
    public key: string = '';

    public active: boolean = false;
    public selected: boolean = false;
    public played: boolean = false;

    public completed: boolean = false;
    public failCount: number = 0;

    public teleportMargin: [number, number] = [0, 0];

    public index: number = 0;

    public constructor(public type: MiniGameTypeEnum) {
        super();

        this.height = 200;
        this.width = 300;
    }

    get aabb(): [number, number, number, number] {
        return [
            this.pos[0] - this.width / 2,
            this.pos[1] - this.height,
            this.width,
            this.height,
        ];
    }
}
